/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IComponentOptions} from 'angular';
import RoleUtilService from '../../../core/service/RoleUtilService';
import {getTSVorleistungArten, TSVorleistungArt, vorleistungArtPrefix} from '../../../models/enums/TSVorleistungArt';
import TSVorleistung from '../../../models/TSVorleistung';
import ILogService = angular.ILogService;
import ITranslateService = angular.translate.ITranslateService;

declare let require: any;
declare let angular: any;

export class DVVorleistungComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        vorleistung: '=',
        name: '@',
    };
    template = require('./dv-vorleistung.html');
    controller = DVVorleistungenController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DVVorleistungenController {

    vorleistung?: TSVorleistung;
    name: string;

    static $inject: any[] = ['CONSTANTS', '$log', 'RoleUtilService', '$translate'];

    /* @ngInject */
    constructor(private CONSTANTS: any, private $log: ILogService, private roleUtilService: RoleUtilService,
                private $translate: ITranslateService) {
        this.$log.debug('initializing vorleistung componente');

    }

    $onInit() {
        if (this.vorleistung === undefined || this.vorleistung === null) {
            this.$log.error('"vorleistung" attribute is required for this component')
        }

    }

    public getModel(): TSVorleistung | undefined {
        return this.vorleistung;
    }

    public getTSVorleistungArtValues(): Array<TSVorleistungArt> {
        return getTSVorleistungArten();
    }

    public translateVorleistungArt(art: TSVorleistungArt): string {
        let prefix = vorleistungArtPrefix();
        return this.$translate.instant(prefix + TSVorleistungArt[art])
    }

    public getPrefix(): string {
        return vorleistungArtPrefix();
    }

    public isPoliceNrVisible(): boolean {
        let vorleistung = this.getModel();
        if (vorleistung !== undefined && vorleistung.vorleistungDatenFS && vorleistung.vorleistungDatenFS.vorleistungenArt) {
            let art = vorleistung.vorleistungDatenFS.vorleistungenArt;
            return (art === TSVorleistungArt.HAGELVERSICHERUNG || art === TSVorleistungArt.GEBAEUDEVERSICHERUNG || art === TSVorleistungArt.PRIVATVERSICHERUNG);
        }
        return false;

    }

}




// WEBPACK FOOTER //
// ./src/app/gesuch/component/dv-vorleistung/dv-vorleistung.ts